import axios from "@/libs/api.request";
// 分公司应退账单
// 获取应退账单列表
export const getClientBill = params => {
  return axios.request({
    url: "/finance/branch/cod/bill/yt",
    method: "get",
    params
  });
};

// 列表明细接口
export const getDetails = params => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/details/${params.id}`,
    method: "get",
    params
  });
};

// 明细详情接口
export const getItemDetails = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/${id}`,
    method: "get"
  });
};

//国家货币汇率
export const getCountryCurrency = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/totalCountryAndRate/${id}`,
    method: "get"
  });
};
// 设置汇率并重新计算
export const saveCountryCurrency = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/reStatistics/${data.id}`,
    method: "post",
    data
  });
};

// 追加订单
export const apendCnbNumbers = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/append/${data.id}`,
    method: "post",
    data
  });
};

// 更新账单
export const updateItem = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/${data.id}`,
    method: "put",
    data
  });
};

// 批量核销
export const batchWriteOff = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/batchWriteOff`,
    method: "post",
    data
  });
};
// 取消核销
export const cancelWriteOff = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/cancelOff/${id}`,
    method: "post"
  });
};

// 删除接口
export const deleteItem = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/${id}`,
    method: "delete"
  });
};

// 详情挂起
export const hangDetails = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/setAbnormal/${data.id}`,
    method: "post",
    data
  });
};

// 详情删除
export const deleteDetails = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/removeOut/${data.id}`,
    method: "post",
    data
  });
};

// 批量确认
export const codConfirmBill = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/confirmed`,
    method: "post",
    data
  });
};

// 批量取消确认
export const cancelConfirmBill = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/yt/cancelConfirm`,
    method: "post",
    data
  });
};
